import { fetchService } from "@/core/services/fetch-service";
import { IContentTreeModel } from "../models/content-tree";

export default class GuideService {
	public getContentTree(sectionName: string): Promise<IContentTreeModel> {
		return fetchService.get<IContentTreeModel>(`/Guide/${sectionName}/ContentTree`);
	}
}

export const guideService = new GuideService();